/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGym = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M19 21H5c-1.7 0-3-1.3-3-3 0-.2 0-.5.1-.7C2.7 14 3.6 9.6 3.9 8c-1.2-1.2-1.5-3.2-.6-4.8l1.7 1c-.3.5-.3 1-.2 1.5s.5.9.9 1.2c1 .6 2.2.2 2.7-.7l1.7 1c-.8 1.6-2.7 2.3-4.4 1.9-.1.5-.2 1.2-.3 1.9H8v2H5c-.1.7-.3 1.4-.4 2H19c1.7 0 3 1.3 3 3s-1.3 3-3 3zm0-2c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1zM7.8 19h8.3c-.1-.3-.2-.6-.2-1s.1-.7.2-1H7.8c.1.3.2.6.2 1s-.1.7-.2 1zM5 17c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgGym as Gym };
